import { render, staticRenderFns } from "./TribRegular.vue?vue&type=template&id=042ec77b&"
import script from "./TribRegular.vue?vue&type=script&lang=js&"
export * from "./TribRegular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports